module.exports = __webpack_public_path__ + "static/media/logo.d5fbbef1.svg";